<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area ci">
      <img :src="`${resources}/img/img-top-sub-title6.jpg`" alt="" />
      <div class="tit_area">
        <div class="sub_tit">CI</div>
        <div class="sub_txt">
          한국오션플랫폼의 Cooperate Identity를 소개합니다.
        </div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <h3>심벌마크</h3>
      <div class="box_line ty_logo">
        <img :src="`${resources}img/img_ci.png`" alt="" />
        <div class="box_line_txt">
          어떠한 방향으로도 닿지 않는 곳이 없게끔 뻗어 나아가는 해저 케이블의
          구조적인 특징을 바탕으로<br />
          유연한 곡선과 연결이 돋보이는 모노그램 스타일의 심볼을
          한국오션플랫폼의 영문 약자 ‘KOP’를 이용하여 디자인 했습니다.<br />
          우측의 말풍선, 물음표가 연상되는 실루엣은 미래를 향한 궁금증, 호기심,
          발전 가능성 등의 도전적인 태도를 담고 있습니다.
        </div>
        <ul class="ci_item">
          <li>
            <i class="color_g"></i>
            <div><strong>CMYK</strong> <span>58 / 48 / 46 / 0</span></div>
            <div><strong>RGB</strong> <span>127 / 128 / 128</span></div>
          </li>
          <li>
            <i class="color_b"></i>
            <div><strong>CMYK</strong> <span>100 / 0 / 70 / 50</span></div>
            <div><strong>RGB</strong> <span>0 / 43 / 105</span></div>
          </li>
          <li>
            <i class="color_br"></i>
            <div><strong>CMYK</strong> <span>36 / 100 / 100 / 3</span></div>
            <div><strong>RGB</strong> <span>182 / 0 / 5</span></div>
          </li>
        </ul>
      </div>

      <h3 class="h3_tit3">디자인 모티브</h3>
      <div class="box_line box_flex mgt40">
        <div class="img_ci02">
          <img :src="`${resources}img/img_ci2.png`" alt="" />
        </div>
        <ul class="ci_item round">
          <li>
            <i class="color_g"></i>
            <ul class="dot_list2">
              <li>해양 건설물로 해양 건설 프로젝트의 시작을 알림</li>
              <li>배의 닻을 형상화</li>
            </ul>
          </li>
          <li>
            <i class="color_b"></i>
            <ul class="dot_list2">
              <li>해저케이블의 모양 및 바다 색깔을 형상화</li>
            </ul>
          </li>
          <li>
            <i class="color_br"></i>
            <ul class="dot_list2">
              <li>도전 정신과 진취적 사고를 상징</li>
              <li>해양 건설이 나아갈 방향의 역동성을 표현</li>
            </ul>
          </li>
        </ul>
      </div>

      <h3>국문</h3>
      <div class="box_line" :class="{ ty_ko: device === 'mo' }">
        <img :src="`${resources}img/img_logo_ko.png`" alt="한성PC건설" />
      </div>
      <h3>영문</h3>
      <div class="box_line" :class="{ ty_en: device === 'mo' }">
        <img :src="`${resources}img/img_logo_en.png`" alt="HANSUNG PCC" />
      </div>
      <div class="box_bg">
        <ul class="dot_list">
          <li>
            시그니처는 한국오션플랫폼의 이미지를 대내외에 표출하는 모든 시각
            커뮤니케이션의 대표 상징물이며, 시그니처의 형태나 색상을 변형하여
            사용하지 않도록 주의를 요합니다.
          </li>
          <li>
            기타 심벌마크의 특수 표현 및 색상 사용 등 CI 사용과 관련한 의문이나
            해석이 필요한 경우 반드시 인사총무팀과 사전 협의하여 적절하게 사용될
            수 있도록 협조하여 주시기 바랍니다.
          </li>
        </ul>
        <div class="down_area align_rht">
          <a
            href="/files/ai/한국오션플랫폼.ai"
            target="_blank"
            rel="noreferrer noopener"
            class="btn_down"
            >AI 다운로드</a
          >
          <a
            href="/files/img/한국오션플랫폼C.I.pdf"
            target="_blank"
            rel="noreferrer noopener"
            class="btn_down"
            >PDF 다운로드</a
          >
        </div>
      </div>
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';
export default {
  mixins: [page]
};
</script>

<style lang="scss" scoped></style>
